const modulos = [
    {
        name: 'Avaliação Funcional',
        menu: {
            icone: '<svg style="width:48px;height:48px" viewBox="0 0 24 24">\n' +
                '    <path fill="currentColor" d="M9 22C8.4 22 8 21.6 8 21V18H4C2.9 18 2 17.1 2 16V4C2 2.9 2.9 2 4 2H20C21.1 2 22 2.9 22 4V16C22 17.1 21.1 18 20 18H13.9L10.2 21.7C10 21.9 9.8 22 9.5 22H9M10 16V19.1L13.1 16H20V4H4V16H10M16.3 6L14.9 9H17V13H13V8.8L14.3 6H16.3M10.3 6L8.9 9H11V13H7V8.8L8.3 6H10.3Z" />\n' +
                '</svg>',

            active: true,
            title: 'AVALIACAO_FUNCIONAL',
            subtitle: 'Acompanhe o desenvolvimento da sua avaliação através de feedbacks constantes e organizados',
            namePath: 'avaliacaofuncional',
            imageMDI: 'fas fa-users',
        }
    },
    {
        name: 'Evolução Funcional',
        menu: {
            icone: '<svg style="width:48px;height:48px" viewBox="0 0 24 24">'+
                '<path fill="currentColor" d="M15,4A4,4 0 0,1 19,8A4,4 0 0,1 15,12A4,4 0 0,1 11,8A4,4 0 0,1 15,4M15,5.9A2.1,2.1 0 0,0 12.9,8A2.1,2.1 0 0,0 15,10.1C16.16,10.1 17.1,9.16 17.1,8C17.1,6.84 16.16,5.9 15,5.9M15,13C17.67,13 23,14.33 23,17V20H7V17C7,14.33 12.33,13 15,13M15,14.9C12,14.9 8.9,16.36 8.9,17V18.1H21.1V17C21.1,16.36 17.97,14.9 15,14.9M5,13.28L2.5,14.77L3.18,11.96L1,10.08L3.87,9.83L5,7.19L6.11,9.83L9,10.08L6.8,11.96L7.45,14.77L5,13.28Z" />'+
                '</svg>',
            active: true,
            title: 'EVOLUCAO_FUNCIONAL',
            subtitle:'Acompanhe o Desenvolvimento na carreira dos profissionais da educação estatutários da Secretaria Municipal de Educação de Manaus (Lei 1.126/2007 e Lei 1.624/2011)',
            namePath: 'evolucaofuncional',
        }
    },
    {
        name: 'Cedência e Disposição',
        menu: {
            icone: '<svg style="width:48px;height:48px" viewBox="0 0 24 24">\n' +
                '    <path fill="currentColor" d="M12 0L11.34 .03L15.15 3.84L16.5 2.5C19.75 4.07 22.09 7.24 22.45 11H23.95C23.44 4.84 18.29 0 12 0M12 4C10.07 4 8.5 5.57 8.5 7.5C8.5 9.43 10.07 11 12 11C13.93 11 15.5 9.43 15.5 7.5C15.5 5.57 13.93 4 12 4M.05 13C.56 19.16 5.71 24 12 24L12.66 23.97L8.85 20.16L7.5 21.5C4.25 19.94 1.91 16.76 1.55 13H.05M12 13C8.13 13 5 14.57 5 16.5V18H19V16.5C19 14.57 15.87 13 12 13Z" />\n' +
                '</svg>',
            active: true,
            title: 'CEDENCIA_DISPOSICAO',
            subtitle:'Acompanhe o andamento dos processos de cedência dos servidores.',
            namePath: 'cedenciadisposicao',
            items: [
                {
                    item: '',
                    namePath: 'cedenciadisposicao',
                }
            ]
        }
    },
    {
        name: 'Administrador',
        menu: {
            icone: '<svg style="width:48px;height:48px" viewBox="0 0 24 24">\n' +
                    '<path fill="currentColor" d="M21.7,13.35L20.7,14.35L18.65,12.3L19.65,11.3C19.86,11.09 20.21,11.09 20.42,11.3L21.7,12.58C21.91,12.79 21.91,13.14 21.7,13.35M12,18.94L18.06,12.88L20.11,14.93L14.06,21H12V18.94M12,14C7.58,14 4,15.79 4,18V20H10V18.11L14,14.11C13.34,14.03 12.67,14 12,14M12,4A4,4 0 0,0 8,8A4,4 0 0,0 12,12A4,4 0 0,0 16,8A4,4 0 0,0 12,4Z" />\n' +
                    '</svg>',
            active: true,
            title: 'ADMINISTRADOR',
            subtitle:'Gestão dos cadastros básicos necessários para o sistema.',
            namePath: 'administrador',
            items: [
                {
                    item: '',
                    namePath: 'administrador',
                }
            ]
        }
    }
]

export default modulos
